<template>
  <div class="wrapper-home">
    <header class="header">
      <div class="wrapper-header">
        <img
          src="https://av-studio-bucket.s3.us-east-1.amazonaws.com/iterrabyte/logos/LogoFull.svg"
          alt="iterrabyte"
          class="logo"
        />
        <p class="header-text">
          Transformamos tus procesos en soluciones tecnológicas que sí funcionan
        </p>
        <button class="button" @click="scrollToContact">
          Hablemos de tu proyecto
        </button>
        <img
          src="https://av-studio-bucket.s3.us-east-1.amazonaws.com/iterrabyte/images/Image1.png"
          alt="software"
          class="header-image"
        />
      </div>
    </header>

    <div class="container-clients">
      <div class="content-clients">
        <p class="title">Empresas que han confiado en nuestro trabajo</p>

        <div class="clients-grid">
          <div
            v-for="(client, index) in clients"
            :key="index"
            class="client"
            @mouseenter="client.hover = true"
            @mouseleave="client.hover = false"
          >
            <img
              :src="client.hover ? client.color : client.mono"
              :alt="client.alt"
              loading="lazy"
            />
          </div>
        </div>
      </div>
    </div>

    <div class="section fade-up">
      <img
        src="https://av-studio-bucket.s3.us-east-1.amazonaws.com/iterrabyte/images/Image2.png"
        alt="code"
        class="image stagger-item"
      />
      <div class="info-section stagger-item">
        <p class="title">
          Convertimos la tecnología en valor real para tu negocio
        </p>
        <p class="text-section stagger-item">
          Automatizamos procesos, desarrollamos soluciones a la medida y
          optimizamos sus sistemas para que todo
          <span class="highlighted">funcione de forma más eficiente</span>
          y sin complicaciones.
        </p>
      </div>
    </div>

    <div class="container-boxes">
      <div class="wrapper-box">
        <img
          src="https://av-studio-bucket.s3.us-east-1.amazonaws.com/iterrabyte/icons/Icon1.svg"
          alt="Optimización de procesos"
          class="icon"
        />

        <p class="title-box">Optimización de procesos</p>
        <p class="text-box">Reducimos errores y tiempos manuales</p>
      </div>
      <div class="wrapper-box">
        <img
          src="https://av-studio-bucket.s3.us-east-1.amazonaws.com/iterrabyte/icons/Icon2.svg"
          alt="Software a la medida
"
          class="icon"
        />

        <p class="title-box">Software a la medida</p>
        <p class="text-box">Desde web hasta móviles, según tu necesidad</p>
      </div>
      <div class="wrapper-box">
        <img
          src="https://av-studio-bucket.s3.us-east-1.amazonaws.com/iterrabyte/icons/Icon3.svg"
          alt="Análisis de datos"
          class="icon"
        />

        <p class="title-box">Análisis de datos</p>
        <p class="text-box">Datos que te ayudan a decidir mejor</p>
      </div>
      <div class="wrapper-box">
        <img
          src="https://av-studio-bucket.s3.us-east-1.amazonaws.com/iterrabyte/icons/Icon4.svg"
          alt="Mantenimiento de software"
          class="icon"
        />

        <p class="title-box">Mantenimiento de software</p>
        <p class="text-box">Corregimos y optimizamos tus sistemas</p>
      </div>
    </div>

    <div class="section fade-up reverse">
      <img
        src="https://av-studio-bucket.s3.us-east-1.amazonaws.com/iterrabyte/images/Image3.png"
        alt="code"
        class="image stagger-item"
      />
      <div class="info-section stagger-item">
        <p class="title">Trabajamos de forma cercana contigo</p>
        <p class="text-section stagger-item">
          Entendemos tu necesidad, analizamos tus procesos y proponemos
          soluciones que realmente se
          <span class="highlighted">adapten a tu forma de trabajar</span>.
        </p>
      </div>
    </div>

    <div class="footer" id="contact">
      <div class="wrapper-footer">
        <p class="footer-title">Cuéntanos tu idea</p>
        <p class="footer-text">
          Te ayudamos a construirla y optimizarla a una solución real
        </p>
        <div class="info phone">
          <img
            src="https://av-studio-bucket.s3.us-east-1.amazonaws.com/iterrabyte/icons/Phone.svg"
            alt="Teléfono de contacto"
            class="icon-footer"
          />
          <p>+57 301 000 00 00 | +57 314 000 00 00</p>
        </div>
        <div class="info email">
          <img
            src="https://av-studio-bucket.s3.us-east-1.amazonaws.com/iterrabyte/icons/Email.svg"
            alt="Correo de contacto"
            class="icon-footer"
          />
          <p>hagamos.negocios@iterrabyte.com</p>
        </div>

        <img
          src="https://av-studio-bucket.s3.us-east-1.amazonaws.com/iterrabyte/logos/Logo.svg"
          alt="iterrabyte"
          class="footer-logo"
        />
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import { clients } from "../../data/home/clients";

export default defineComponent({
  name: "HomeView",

  data() {
    return {
      clients: clients.map((client) => ({
        ...client,
        hover: false,
      })),
    };
  },

  methods: {
    scrollToContact() {
      const el = document.getElementById("contact");
      if (el) {
        el.scrollIntoView({ behavior: "smooth" });
      }
    },
  },

  mounted() {
    const sections = document.querySelectorAll(".fade-up");

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            const el = entry.target as HTMLElement;

            el.classList.add("visible");

            const children = el.querySelectorAll(".stagger-item");
            children.forEach((child, index) => {
              setTimeout(() => {
                child.classList.add("visible");
              }, index * 150);
            });

            observer.unobserve(el);
          }
        });
      },
      {
        root: null,
        rootMargin: "-35% 0px -35% 0px",
        threshold: 0,
      }
    );

    sections.forEach((section) => observer.observe(section));
  },
});
</script>

<style scoped lang="scss">
@import "src/ux/home/styles/homeStyle";
</style>
